import React from 'react'
import { Box } from '@mui/material'
import Value from './Value'
import Riichi from './Riichi'
import Status from './Status'
import './Score.scss'

const Score = ({ score }) => {
  return (
    <Box className="score">
      <Box className="grid-value">
        <Value score={score} />
      </Box>
      <Box className="grid-riichi">
        {score.riichi && <Riichi riichi={score.riichi} />}
      </Box>
      <Box className="grid-status">
        <Status score={score} />
      </Box>
    </Box>
  )
}

export default Score
